export const keywordsBase = ["Disponible en Bogotá"];
